// Variables
const animationDuration = 3000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round( animationDuration / frameDuration );
const easeOutQuad = (t) => t * ( 2 - t );

/**
 * Inside the section--numbers-list we want to animate the numbers in the text columns.
 * We want to start on 0 and count up to the target number in a certain duration (animationDuration)
 *
 * For this to work:
 *     - The section needs the "section--numbers-list" class
 *     - we need to use "two text elements" Element
 *         - on the left column the number must be styled with "teasertext" style
 *
 * The animation runs when the element is at least 50% visible
 */
export function initCountingNumbers() {
  // Get elements
  const numberElements = document.querySelectorAll('.section--numbers-list .text-columns .teasertext');
  if (!numberElements) return;

  numberElements.forEach((numberElement) => {
    const initialText = numberElement.textContent;
    const numberValue = parseFloat(numberElement.textContent);
    if (!numberValue || isNaN(numberValue)) return;

    numberElement.textContent = '0';

    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
          animateNumber(numberElement, numberValue, initialText);
          observer.unobserve(numberElement);
        }
      })
    }, { threshold: 1.0 });

    observer.observe(numberElement);
  });
}


/**
 * Animate a number from 0 up to the target value
 *
 * @param numberElement
 * @param targetValue
 */
function animateNumber(numberElement, targetValue, initialText) {
  let frame = 0;
  const counter = setInterval(() => {
    frame++;
    const progress = easeOutQuad(frame / totalFrames);
    const currentCount = Math.round(targetValue * progress);

    if (parseFloat(numberElement.textContent) !== currentCount) {
      numberElement.textContent = currentCount;
    }

    if (frame === totalFrames) {
      numberElement.textContent = initialText;
      clearInterval(counter);
    }
  }, frameDuration);
}
